__turbopack_context__.v({
  "blogDescription": "Blog-module__YuIbtq__blogDescription",
});
